// Auto-generated enums — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
//
// Each enum is emitted twice: a string-literal union TYPE for
// annotations, and an `as const` VALUE object so callers can reference
// `Practice.TheInstrument` instead of hand-typing the wire string.

export type AdminUserSort = 'SignedUp' | 'Email' | 'Name';

export const AdminUserSort = {
  SignedUp: 'SignedUp',
  Email: 'Email',
  Name: 'Name',
} as const satisfies Record<string, AdminUserSort>;

export type AiCreditSource = 'AiReview' | 'ActiveListening' | 'LiveConvo' | 'RehearsalPlan' | 'RehearsalPdfRecognition';

export const AiCreditSource = {
  AiReview: 'AiReview',
  ActiveListening: 'ActiveListening',
  LiveConvo: 'LiveConvo',
  RehearsalPlan: 'RehearsalPlan',
  RehearsalPdfRecognition: 'RehearsalPdfRecognition',
} as const satisfies Record<string, AiCreditSource>;

export type AiReviewFailureKind = 'TooShort' | 'TooLong' | 'InsufficientCredits' | 'HighDemand' | 'InternalError' | 'ReviewUnreachable' | 'UploadNeverCompleted' | 'ReviewNeverStarted' | 'RecordingUnavailable';

export const AiReviewFailureKind = {
  TooShort: 'TooShort',
  TooLong: 'TooLong',
  InsufficientCredits: 'InsufficientCredits',
  HighDemand: 'HighDemand',
  InternalError: 'InternalError',
  ReviewUnreachable: 'ReviewUnreachable',
  UploadNeverCompleted: 'UploadNeverCompleted',
  ReviewNeverStarted: 'ReviewNeverStarted',
  RecordingUnavailable: 'RecordingUnavailable',
} as const satisfies Record<string, AiReviewFailureKind>;

export type AiReviewLifecycle = 'Started' | 'Completed' | 'Failed' | 'Pending';

export const AiReviewLifecycle = {
  Started: 'Started',
  Completed: 'Completed',
  Failed: 'Failed',
  Pending: 'Pending',
} as const satisfies Record<string, AiReviewLifecycle>;

export type ChatModelRole = 'Auto' | 'PinnedOnly';

export const ChatModelRole = {
  Auto: 'Auto',
  PinnedOnly: 'PinnedOnly',
} as const satisfies Record<string, ChatModelRole>;

export type ChatWorkload = 'Text' | 'Document';

export const ChatWorkload = {
  Text: 'Text',
  Document: 'Document',
} as const satisfies Record<string, ChatWorkload>;

export type CreditAction = 'Review' | 'DeliveryPlan' | 'RewriteForSpeaking';

export const CreditAction = {
  Review: 'Review',
  DeliveryPlan: 'DeliveryPlan',
  RewriteForSpeaking: 'RewriteForSpeaking',
} as const satisfies Record<string, CreditAction>;

export type CreditLedgerKind = 'SignupBonus' | 'Purchase' | 'PackRefund' | 'SupportAdjustment' | 'MonthlyAllowance' | 'Charge' | 'LiveTake';

export const CreditLedgerKind = {
  SignupBonus: 'SignupBonus',
  Purchase: 'Purchase',
  PackRefund: 'PackRefund',
  SupportAdjustment: 'SupportAdjustment',
  MonthlyAllowance: 'MonthlyAllowance',
  Charge: 'Charge',
  LiveTake: 'LiveTake',
} as const satisfies Record<string, CreditLedgerKind>;

export type CueDirection = 'Neutral' | 'Faster' | 'Slower' | 'Louder' | 'Softer' | 'Higher' | 'Lower' | 'Legato' | 'Staccato' | 'Melody' | 'RiseFall' | 'Bounce' | 'Flat' | 'Steady' | 'RaceBrake' | 'BoomMurmur';

export const CueDirection = {
  Neutral: 'Neutral',
  Faster: 'Faster',
  Slower: 'Slower',
  Louder: 'Louder',
  Softer: 'Softer',
  Higher: 'Higher',
  Lower: 'Lower',
  Legato: 'Legato',
  Staccato: 'Staccato',
  Melody: 'Melody',
  RiseFall: 'RiseFall',
  Bounce: 'Bounce',
  Flat: 'Flat',
  Steady: 'Steady',
  RaceBrake: 'RaceBrake',
  BoomMurmur: 'BoomMurmur',
} as const satisfies Record<string, CueDirection>;

export type CueKind = 'Auditory' | 'Visual' | 'Archetype' | 'Help';

export const CueKind = {
  Auditory: 'Auditory',
  Visual: 'Visual',
  Archetype: 'Archetype',
  Help: 'Help',
} as const satisfies Record<string, CueKind>;

export type FrameworkLens = 'FourMat' | 'StorytellingFormula' | 'Vaks' | 'Ams';

export const FrameworkLens = {
  FourMat: 'FourMat',
  StorytellingFormula: 'StorytellingFormula',
  Vaks: 'Vaks',
  Ams: 'Ams',
} as const satisfies Record<string, FrameworkLens>;

export type ImpersonationDeniedAction = 'AccountDeletion' | 'BillingWrite' | 'EmailChange';

export const ImpersonationDeniedAction = {
  AccountDeletion: 'AccountDeletion',
  BillingWrite: 'BillingWrite',
  EmailChange: 'EmailChange',
} as const satisfies Record<string, ImpersonationDeniedAction>;

export type LearningStage = 'UnconsciousIncompetence' | 'ConsciousIncompetence' | 'ConsciousCompetence' | 'UnconsciousCompetence';

export const LearningStage = {
  UnconsciousIncompetence: 'UnconsciousIncompetence',
  ConsciousIncompetence: 'ConsciousIncompetence',
  ConsciousCompetence: 'ConsciousCompetence',
  UnconsciousCompetence: 'UnconsciousCompetence',
} as const satisfies Record<string, LearningStage>;

export type LiveConversationKind = 'ActiveListening' | 'Pitch';

export const LiveConversationKind = {
  ActiveListening: 'ActiveListening',
  Pitch: 'Pitch',
} as const satisfies Record<string, LiveConversationKind>;

export type LiveConvoEndReason = 'UserEnded' | 'CapReached' | 'Idle' | 'CreditsOut' | 'ProviderFailed' | 'ConnectionLost' | 'Expired' | 'Rejected';

export const LiveConvoEndReason = {
  UserEnded: 'UserEnded',
  CapReached: 'CapReached',
  Idle: 'Idle',
  CreditsOut: 'CreditsOut',
  ProviderFailed: 'ProviderFailed',
  ConnectionLost: 'ConnectionLost',
  Expired: 'Expired',
  Rejected: 'Rejected',
} as const satisfies Record<string, LiveConvoEndReason>;

export type LiveConvoInstruction = 'WrapUp' | 'CheckIn' | 'Greeting' | 'Interject';

export const LiveConvoInstruction = {
  WrapUp: 'WrapUp',
  CheckIn: 'CheckIn',
  Greeting: 'Greeting',
  Interject: 'Interject',
} as const satisfies Record<string, LiveConvoInstruction>;

export type LiveConvoTransport = 'WebRtc' | 'Relay';

export const LiveConvoTransport = {
  WebRtc: 'WebRtc',
  Relay: 'Relay',
} as const satisfies Record<string, LiveConvoTransport>;

export type LiveConvoVoiceGender = 'Female' | 'Male';

export const LiveConvoVoiceGender = {
  Female: 'Female',
  Male: 'Male',
} as const satisfies Record<string, LiveConvoVoiceGender>;

export type LivePanelCueKind = 'Open' | 'React' | 'Interject' | 'CheckIn' | 'WrapUp' | 'Feedback' | 'Verdict' | 'Starter' | 'Opening';

export const LivePanelCueKind = {
  Open: 'Open',
  React: 'React',
  Interject: 'Interject',
  CheckIn: 'CheckIn',
  WrapUp: 'WrapUp',
  Feedback: 'Feedback',
  Verdict: 'Verdict',
  Starter: 'Starter',
  Opening: 'Opening',
} as const satisfies Record<string, LivePanelCueKind>;

export type LivePanelReleaseKind = 'Done' | 'CutOff' | 'NoShow' | 'Lost';

export const LivePanelReleaseKind = {
  Done: 'Done',
  CutOff: 'CutOff',
  NoShow: 'NoShow',
  Lost: 'Lost',
} as const satisfies Record<string, LivePanelReleaseKind>;

export type LivePitchStarter = 'Audibility' | 'Readiness' | 'CheckIn' | 'Wellbeing' | 'Thanks' | 'Introduction' | 'Greeting';

export const LivePitchStarter = {
  Audibility: 'Audibility',
  Readiness: 'Readiness',
  CheckIn: 'CheckIn',
  Wellbeing: 'Wellbeing',
  Thanks: 'Thanks',
  Introduction: 'Introduction',
  Greeting: 'Greeting',
} as const satisfies Record<string, LivePitchStarter>;

export type MasteryElement = 'RateOfSpeech' | 'Volume' | 'PitchAndMelody' | 'Tonality' | 'Pause' | 'FacialExpression' | 'Gesture' | 'EyeContact';

export const MasteryElement = {
  RateOfSpeech: 'RateOfSpeech',
  Volume: 'Volume',
  PitchAndMelody: 'PitchAndMelody',
  Tonality: 'Tonality',
  Pause: 'Pause',
  FacialExpression: 'FacialExpression',
  Gesture: 'Gesture',
  EyeContact: 'EyeContact',
} as const satisfies Record<string, MasteryElement>;

export type MusicMood = 'setup' | 'reflection' | 'mystery' | 'tension' | 'humor' | 'escalation' | 'climax' | 'resolution';

export const MusicMood = {
  Setup: 'setup',
  Reflection: 'reflection',
  Mystery: 'mystery',
  Tension: 'tension',
  Humor: 'humor',
  Escalation: 'escalation',
  Climax: 'climax',
  Resolution: 'resolution',
} as const satisfies Record<string, MusicMood>;

export type PlanStatus = 'Active' | 'Completed' | 'Abandoned';

export const PlanStatus = {
  Active: 'Active',
  Completed: 'Completed',
  Abandoned: 'Abandoned',
} as const satisfies Record<string, PlanStatus>;

export type Practice = 'TheInstrument' | 'ArchetypePlay' | 'BodyLanguagePlay' | 'Storytelling' | 'RecordAndReview' | 'ActiveListening' | 'Riff' | 'Standalone';

export const Practice = {
  TheInstrument: 'TheInstrument',
  ArchetypePlay: 'ArchetypePlay',
  BodyLanguagePlay: 'BodyLanguagePlay',
  Storytelling: 'Storytelling',
  RecordAndReview: 'RecordAndReview',
  ActiveListening: 'ActiveListening',
  Riff: 'Riff',
  Standalone: 'Standalone',
} as const satisfies Record<string, Practice>;

export type PracticeMode = 'Standard' | 'LiveConvo' | 'LivePitch';

export const PracticeMode = {
  Standard: 'Standard',
  LiveConvo: 'LiveConvo',
  LivePitch: 'LivePitch',
} as const satisfies Record<string, PracticeMode>;

export type PracticeQuotaScope = 'Anonymous' | 'User' | 'Premium';

export const PracticeQuotaScope = {
  Anonymous: 'Anonymous',
  User: 'User',
  Premium: 'Premium',
} as const satisfies Record<string, PracticeQuotaScope>;

export type PronunciationAccent = 'UsEnglish' | 'BritishEnglish';

export const PronunciationAccent = {
  UsEnglish: 'UsEnglish',
  BritishEnglish: 'BritishEnglish',
} as const satisfies Record<string, PronunciationAccent>;

export type RecordingUploadState = 'Recorded' | 'AwaitingBytes';

export const RecordingUploadState = {
  Recorded: 'Recorded',
  AwaitingBytes: 'AwaitingBytes',
} as const satisfies Record<string, RecordingUploadState>;

export type ReviewFrameRate = 'Quarter' | 'Half' | 'Full';

export const ReviewFrameRate = {
  Quarter: 'Quarter',
  Half: 'Half',
  Full: 'Full',
} as const satisfies Record<string, ReviewFrameRate>;

export type RiffWordCategory = 'Everyday' | 'Business' | 'Technology' | 'Faith' | 'Specialist';

export const RiffWordCategory = {
  Everyday: 'Everyday',
  Business: 'Business',
  Technology: 'Technology',
  Faith: 'Faith',
  Specialist: 'Specialist',
} as const satisfies Record<string, RiffWordCategory>;

export type SaveReason = 'Library' | 'Review' | 'AutoSave';

export const SaveReason = {
  Library: 'Library',
  Review: 'Review',
  AutoSave: 'AutoSave',
} as const satisfies Record<string, SaveReason>;

export type SelfReviewCheck = 'Visual' | 'Auditory';

export const SelfReviewCheck = {
  Visual: 'Visual',
  Auditory: 'Auditory',
} as const satisfies Record<string, SelfReviewCheck>;

export type SubscriptionStatus = 'None' | 'Active' | 'PastDue' | 'Cancelled' | 'Expired';

export const SubscriptionStatus = {
  None: 'None',
  Active: 'Active',
  PastDue: 'PastDue',
  Cancelled: 'Cancelled',
  Expired: 'Expired',
} as const satisfies Record<string, SubscriptionStatus>;

export type ThinkingLevel = 'Minimal' | 'Low' | 'Medium' | 'High';

export const ThinkingLevel = {
  Minimal: 'Minimal',
  Low: 'Low',
  Medium: 'Medium',
  High: 'High',
} as const satisfies Record<string, ThinkingLevel>;

export type UploadReason = 'Review' | 'Progress' | 'Library';

export const UploadReason = {
  Review: 'Review',
  Progress: 'Progress',
  Library: 'Library',
} as const satisfies Record<string, UploadReason>;

export type WaitlistSlotStatus = 'Waiting' | 'Admitted' | 'Expired';

export const WaitlistSlotStatus = {
  Waiting: 'Waiting',
  Admitted: 'Admitted',
  Expired: 'Expired',
} as const satisfies Record<string, WaitlistSlotStatus>;

